import { Checkbox, Group } from "@mantine/core";

interface Props {
  options: string[];
  value: string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
}
export function PrefixCheckboxFilter({
  options,
  value,
  onChange,
  disabled,
}: Props) {
  return (
    <Checkbox.Group label="Case prefixes" value={value} onChange={onChange}>
      <Group gap="xs" mt={4}>
        {options.map((prefix) => (
          <Checkbox
            key={prefix}
            value={prefix}
            disabled={disabled}
            label={
              prefix === "__OTHER__" ? "Other / nonstandard number" : prefix
            }
            size="xs"
          />
        ))}
      </Group>
    </Checkbox.Group>
  );
}
